import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UigCheckoutService } from '../../uig-checkout/uig-checkout.service';
import { UigCartGroupingService } from '../uig-cart-grouping/uig-cart-grouping.service';
import { UigCartTotalsComponent } from '../uig-cart-totals/uig-cart-totals.component';
import { VendorOrderEntryGroup } from '../uig-cart.models';

@Component({
    selector: 'app-uig-vendor-order-summary',
    templateUrl: './uig-vendor-order-summary.component.html',
    styleUrls: ['./uig-vendor-order-summary.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigVendorOrderSummaryComponent extends UigCartTotalsComponent implements OnInit{

  @Input() isCheckout: boolean = false;
  vendorEntryGroups$: Observable<VendorOrderEntryGroup[]>;
  pickup$: Observable<boolean>;
  directDeliveryMode$: Observable<boolean>;

  constructor(
    protected activeCartService: ActiveCartService,
    protected userAccountFacade: UserAccountFacade,
    protected uigCartGroupingService: UigCartGroupingService,
    protected uigCheckoutService: UigCheckoutService) {
    super(activeCartService, userAccountFacade);
    this.pickup$ = this.uigCheckoutService.pickup;
    this.directDeliveryMode$ = this.uigCheckoutService.deliveryAddressMode;
  }

  ngOnInit() {
    super.ngOnInit();
    this.vendorEntryGroups$ = this.cart$.pipe(map((cart) => {
      return this.uigCartGroupingService.groupByVendor(cart.entries, cart.groupSums);
    }))
  }
  }
